import { render } from "./ModaleCreationWidget.vue?vue&type=template&id=8a21f02e&scoped=true&ts=true"
import script from "./ModaleCreationWidget.vue?vue&type=script&lang=ts"
export * from "./ModaleCreationWidget.vue?vue&type=script&lang=ts"

import "./ModaleCreationWidget.vue?vue&type=style&index=0&id=8a21f02e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a21f02e"]])

export default __exports__